import * as types from '../constants/ActionTypes';

export const initialState = { ticker: {} };

export default function ticker(state = initialState, action = {}) {
    switch (action.type) {
        case types.GET_TICKER_SUCCESS:
            return {
                ...state,
                ticker: action.result
            };
        default:
            return state;
    }
}
